import { SEARCH_PAGE } from "./constants";

export const getPageName = state => state.page.name;

export const getIsSearchPage = state => getPageName(state) === SEARCH_PAGE;

export const getIsLoading = state => state.page.isLoading;

export const getIsServerRendered = state => state.page.isServerRendered;
